import { createFileRoute } from '@tanstack/react-router'

import { CampaignsPage } from '#/modules/campaigns/campaigns-page'

function validateCampaignsSearch(
  search: Record<string, unknown>,
): { view?: 'product' | 'automations' } & Record<string, unknown> {
  const { view, ...rest } = search
  return view === 'product' || view === 'automations' ? { ...rest, view } : rest
}

export const Route = createFileRoute('/_shell/campaign/')({
  component: CampaignsPage,
  validateSearch: validateCampaignsSearch,
})
